const clubsPageStyles = {
  card: {
    margin: '24px',
    overflow: 'auto',
    flexGrow: 1,
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  cardTitle: {
    fontWeight: 'bold',
  },
  divider: {
    marginBottom: '16px',
  },
  searchField: {
    width: '400px',
  },
  tableContainer: {
    marginTop: '16px',
    maxHeight: 'calc(100dvh - 250px)',
    overflow: 'auto',
  },
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  clubNameCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  clubLogo: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    objectFit: 'cover',
  },
}

export default clubsPageStyles
